<template>
  <section class="contact_page  no_banner_page clearfix">
  <div class=" main main_white  perm_new_page container has_bg">
    <h1 class="cat_title">כרמלה בקבוע</h1>
    <div>
      <div>
        <div class="clearfix z--1">
          <h2 class="custom-title">כל מה שאוהבים, מגיע קבוע הביתה טרי וטעים!</h2>
          <div class="bt_green ease no_mobile">
            <a href="javascript:void(0);" style="margin: 0" @click="continuePermanent">ליצירת הזמנה קבועה</a>
            <br/><br/>
          </div>
        </div>
        <div class="perma_rows z--1">
          <div class="perma_row clearfix">
            <div class="right perma_item">
              <div class="perma_icon">
                <HEART/>
              </div>
              <div class="text">
                בחרת עגלה מלאה במוצרים אהובים. הפכת אותה להזמנה קבועה. מעכשיו
                היא תגיע אליך הביתה, באופן קבוע, פעם בשבוע (או פעמיים, לפי מה
                שנוח וצריך) כדי שתמיד יהיו דברים טעימים לבשל ולאכול.
              </div>
            </div>
            <div class="right perma_item">
              <div class="perma_icon">
                <OK/>
              </div>
              <div class="text">זה אומר שמטלה אחת ירדה לך מהראש, ובצורה המפנקת ביותר.</div>
            </div>
            <div class="right perma_item">
              <div class="perma_icon">
                <PEN/>
              </div>
              <div class="text">תמיד אפשר לערוך את ההזמנה, לשנות, להוסיף ולבטל.</div>
            </div>
          </div>
          <div class="perma_row clearfix">
            <div class="right perma_item">
              <div class="perma_icon">
                <TIME/>
              </div>
              <div class="text">תמיד נשלח תזכורת יום לפני המשלוח, כדי לוודא שהכל בסדר.</div>
            </div>
            <div class="right perma_item">
              <div class="perma_icon">
                <PRESET/>
              </div>
              <div class="text">מוצר מתנה בהפתעה עם כל משלוח</div>
            </div>
          </div>
          <div class="mobile_only bt_green perma-botn ease" >
            <a class="not-width-100" href="javascript:void(0);" @click="continuePermanent">ליצירת הזמנה קבועה</a>
          </div>
        </div>
      </div>

    </div>
  </div>
  </section>
</template>

<script>
  import Product from "../components/Product/Product.vue";
  import PLUS from "../assets/img/plus.svg";
  import CLOSE from "../assets/img/close.svg";
  import VOK from "../assets/img/ok.svg";
  // import OrderDetails from "./Components/PermenantOrderDetails";
  /* SVG import */
  import HEART from "../assets/img/heart.svg";
  import OK from "../assets/img/check-ok.svg";
  import PEN from "../assets/img/pen-magic.svg";
  import SEARCH from "../assets/img/search.svg";
  import TIME from "../assets/img/time2.svg";
  import PRESET from "../assets/img/present.svg";
  import Calendar from "../assets/img/calander.svg";
  import {mapActions, mapGetters, mapState} from "vuex";
  import OrderStatusChange from "@/components/Popups/orderStatusChange";

  export default {
    name: "perm_page_new",
    data() {
      return {
        currency: wpData.currencySumbol,
        loaderGif: wpData.assets_url + "/layout/loader.gif",
        ajaxLoader: wpData.assets_url + "/layout/ajax-loader.gif",
        pageLoaded: false,
        permanentorder: false,
        continueEnter: false,
        hideText: false,
        hideTips: false,
        search: '',
        products: [],
        showTips: true,
        shippmentDetails: false,
        editPerOrder: false,
        editPerOrderNew: false,
        assets_url: wpData.assets_url,
        orderToEdit: this.permOrder,
        saveingOrder: false,
        orders: [],
        allOrders: [],
        days: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי"]
      };
    },
    watch: {
      orders: function (value) {
        if (value) {
          this.permanentorder = true;
        }
      },
      search: function (value) {
        if (value && value.length > 2) {

          this.searchProducts(value);
        }

      },
    },
    computed: {
      ...mapGetters(["allProducts"]),
      ...mapState(["permOrder", "permOrderEdit","permOrderLoaded"]),
      user() {
        return this.$store.state.userLoggedInfo;
      },
      orderSent(){
        let waiting_order = false;
        this.allOrders.map(order => {
          if (typeof order == 'object' && order.is_edit){
            waiting_order = true;
          }
        })
        return waiting_order;
      },
      showEnterScreen() {

        return true;
      },
      initTooltips(){
        if (this.permOrder){
          this.$store.dispatch("initToolTip");
        }
        return true;
      },
      results() {
        if (!this.search || this.search == "") {
          return false;
        }
        // var productsFound = this.products.filter(product => {
        //   return product.name.toLowerCase().includes(this.search.toLowerCase());
        // });
        return this.products;
      },
      permanentproducts() {
        if (this.$store.state.permanentproducts && this.$store.state.permanentproducts.length > 0) {
          this.showTips = false;
          return this.$store.state.permanentproducts;
        }
        this.showTips = true;
        return false;
      }
    },
    mounted() {
      this.$ajax.get(ajaxUrl + "?action=getOrders").then(response => {
        this.loaded = true;
        if (response.data) {
          this.allOrders = response.data;
        }
      });
      this.$root.$on('editPermOrder',(event) =>{
        if (typeof  event !='undefined' &&  typeof event.editOrder !='undefined'){
          this.editOrder(this.permOrder,true);
        }
      })
      if (this.permanentproducts) {
        this.continuePermanent();
      }
    },
    methods: {
      ...mapActions(["addToPermanent"]),
      toggleHideText(){
        this.hideText = true;
        window.scrollTo(0,0);
      },
      toggleShowTips() {
        this.showTips = false;
      },

      searchProducts(s) {
        //this.loadingResults = true;
        this.$ajax({
          method: "POST",
          url: homeUrl + "ajax.php",
          params: {
            search: s
          }
        }).then(res => {
          let foundProducts = res.data;
          if (typeof foundProducts != 'undefined' && foundProducts.length > 0) {

            foundProducts.sort(function (a, b) {
              if (
                  a.categories.includes(16) ||
                  a.categories.includes(105) ||
                  a.categories.includes(22)
              ) {
                return -1;
              }
              if (
                  b.categories.includes(16) ||
                  b.categories.includes(105) ||
                  b.categories.includes(22)
              ) {
                return 1;
              }
              return 0;
            });
          }
          //this.loadingResults = false;
          this.products = foundProducts;
          // resolve(foundProducts);

        });
      },
      saveNewOrder() {
        this.saveingOrder = true;
        let products_to_send = this.$store.getters.cartJSON ? this.$store.getters.cartJSON:false;
        this.$store.state.permOrder.products = this.$store.state.added;

        this.$store.dispatch("updatePermanentOrder", products_to_send).then(() => {
          this.$modal.show(OrderStatusChange, {status: 1,sendToComax: false});
          this.orderToEdit = false;
          this.editPerOrder = false;
          this.saveingOrder = false;
          this.$store.state.added = [];
        });
      },
      changeStatus(status, order_id) {
        this.$store.state.permOrder.status = status;
        this.changeOrderStatus([status, order_id]);
        this.$store.commit('setPermOrderEdit', false);
        this.$modal.show(OrderStatusChange, {status: status, sendToComax: true});

      },
      changeStatusAndSave(status, order_id){
        this.saveOrderStatus([status,order_id]);
        this.$store.commit('setPermOrderEdit', false);
        this.$modal.show(OrderStatusChange, {status: status, sendToComax: false});
      },
      getProduct(id) {
        let tmp = this.allProducts;
        return tmp.find(p => p.id == id);
      },
      continuePermanent() {
        this.$modal.show("login-modal",{redirect: true});
        //this.$router.push({name: 'permenent'});

      },
      handelSearch(value) {
        if (value) {
          this.showTips = false;
        }
      },
      continueOrder() {
        this.shippmentDetails = true;
        this.$store.commit('setPremenantOrder', true);
        let indexesToRemove = [];
        let perProductsToAdd = this.$store.state.permanentproducts;
        perProductsToAdd.map(product => {
          this.$store.dispatch('updateCart', [product]);
        })
        /*
        let cart = this.$store.state.added;
      console.log(cart);
      console.log(this.$store.state.permanentproducts);
        for (const key in cart) {
            let find = this.$store.state.permanentproducts.find(p => p.id == cart[key].id )
          console.log(find);
            if (typeof find == 'undefined'){
                indexesToRemove.push(key);
            }
        }
        indexesToRemove.map(index => {
            this.$store.state.added.splice(index,1);
        })
        */

        if (this.editPerOrder) {
          this.$store.commit('setPerEdit', this.orderToEdit);
        }
        this.$router.replace({
          path: "/checkout/",
        });
      },
      editOrderDetails(order) {
        this.clarCart();

        this.$store.commit('setPremenantOrder', true);

        this.editPerOrder = true;
        this.$store.commit('clearPermenant');
        this.$store.commit('setPerEdit', order);
        order.products.map(product => {
          this.$store.commit('setPermenant', product);
          this.$store.dispatch('updateCart', [product]);
        });

        this.$router.replace({
          path: "/checkout/",
        });
      },
      editOrder(order,send = false) {
        if (!send && order && order.order_sent && this.orderSent){
          this.$modal.show(PerOrderSent);
          return;
        }
        this.clarCart();
        this.$store.commit('hideAlert',true);
        this.$store.commit('setPermOrderEdit', true);
        this.orderToEdit = order;
        this.$store.commit('clearPermenant');
        this.$store.commit('setPerEdit', order);
        order.products.map(product => {
          this.$store.dispatch('updateCart', [product]);
          this.$store.commit('setPermenant', product);
        });
        this.$store.commit('hideAlert',false);

      },
      closeSearch() {
        this.search = "";
      },
      isProductInPerm(productID) {
        if (this.permanentproducts){

          let product = this.permanentproducts.find(p => p.id == productID);
          if (product) {
            return true;
          }
        }
        return false;
      },
      ...mapActions([
        "updateCart",
        "getProductById",
        "incrementProduct",
        "decrementProduct",
        "removeProduct",
        "updateSelect",
        "clarCart",
        "changeOrderStatus",
        "saveOrderStatus"
      ])
    },
    components: {
      Product,
      HEART,
      OK,
      PEN,
      TIME,
      PRESET,
      PLUS,
      CLOSE,
      VOK,
      //  OrderDetails,
      Calendar
    }
  };
</script>

<style>
  .perma_results {
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 425px;
    position: relative;
    width: 100%;
    z-index: 3;
    background: #fff;
  }
  .permLoader img {
    max-width: 40px;
    margin: 20px;
  }
  .permLoader.savingOrderLoader {
    text-align: left;
    position: absolute;
    left: 50px;
    top: 15px;
  }
  .prod_in_order .product_wrap .addto_amount{pointer-events: none;}

  @media screen and (max-width: 800px) {
    .permLoader.savingOrderLoader {
      text-align: left;
      position: absolute;
      left: 0;
      top: -20px;
    }
  }
</style>

<style lang="sass" scoped>
  .custom-title
    text-align: right
    margin-bottom: 30px

  .page-template-perm_page_new .main h1.cat_title
    text-align: right

  .not-width-100
    width: auto
    display: inline-block
    margin: 0 auto
    // padding:

  /* Mobile */
  @media screen and (max-width: 800px)

    .custom-title,
    .perma-botn,
    .page-template-perm_page_new .main h1.cat_title
      text-align: center

    .not-width-100
      padding: 0 1.25rem

</style>

